export class RegistrationPage {
  static Set_Registration_Page_State = "Set_Registration_Page_State";
  static Validate_User = "Validate_User";
  static Create_Merchant = "Create_Merchant";
  static Logged_In_User = "Logged_In_User";
}

export class LoginPage {
  static Set_Login_Page_State = "Set_Login_Page_State";
}

export class MerchantHomePage {
  static Set_Merchant_HomePage_State = "Set_Merchant_HomePage_State";
  static Set_Get_Merchant_State = "Set_Get_Merchant_State";
}

export class MerchantCategories {
  static Set_Merchant_Category_State = "Set_Merchant_Category_State";
  static Set_GetMerchant_Category_State = "Set_GetMerchant_Category_State";
}

export class LandingPage {
  static Set_Landing_Page_State = "Set_Landing_Page_State";
  static Landing_Page_Validate_User = "Landing_Page_Validate_User";
}
export class UserValidation {
  static Set_User_Validation_State = "Set_User_Validation_State";
  static Get_Logged_In_User = "Get_Logged_In_User";
}

export class UserAuthentication {
  static SET_USER_AUTHENTICATION = "SET_USER_AUTHENTICATION";
  static GET_USER_AUTHENTICATION = "GET_USER_AUTHENTICATION";
  static GET_USER = "GET_USER";
}

export class MerchantBillers {
  static Set_Merchant_Biller_State = "Set_Merchant_Biller_State";
  static Set_GetMerchant_Biller_State = "Set_GetMerchant_Biller_State";
  static Get_All_Merchant_Billers = "Get_All_Merchant_Billers";
  static Add_Biller = "Add_Biller";
  static Get_Excluded_Billers = "Get_Excluded_Billers";
}

export class MerchantProducts {
  static Set_Merchant_Product_State = "Set_Merchant_Product_State";
  static Set_GetMerchant_Product_State = "Set_GetMerchant_Product_State";
  static Filter_Product = "Filter_Product";
}

export class MerchantComission {
  static Set_Merchant_Commission_State = "Set_Merchant_Commission_State";
  static Set_GetMerchant_Commission_State = "Set_GetMerchant_Commission_State";
}
export class MerchantProfiles {
  static Set_Merchant_Profile_State = "Set_Merchant_Profile_State";
  static Set_GetMerchant_Profile_State = "Set_GetMerchant_Profile_State";
  static Set_update_Merchant_Profile_State =
    "Set_update_Merchant_Profile_State";
  static Set_Update_Kyc_State = "Set_Update_Kyc_State";
}

export class MerchantRoles {
  static Set_GetMerchant_Permission_State = "Set_GetMerchant_Permission_State";
  static Set_Merchant_Role_State = "Set_Merchant_Role_State";
  static Set_GetMerchant_Role_State = "Set_GetMerchant_Role_State";
  static Create_Role = "Create_Role";
}
export class MerchantUser {
  static Set_Merchant_User_State = "Set_Merchant_User_State";
  static Set_GetMerchant_User_State = "Set_GetMerchant_User_State";
  static Create_Merchant_User = "Create_Merchant_User";
}
export class MerchantDashboard {
  static Set_Merchant_DashboardBalance_State =
    "Set_Merchant_DashboardBalance_State";
  static Set_GetMerchant_DashboardBalance_State =
    "Set_GetMerchant_DashboardBalance_State";
  static Set_Merchant_DashboardTop10_State =
    "Set_Merchant_DashboardTop10_State";
  static Set_GetMerchant_DashboardTop10_State =
    "Set_GetMerchant_DashboardTop10_State";
  static Set_Merchant_DashboardStatistics_State =
    "Set_Merchant_DashboardStatistics_State";
  static Set_GetMerchant_DashboardStatistics_State =
    "Set_GetMerchant_DashboardStatistics_State";
  static Get_Merchant_Dashboard_State = "Get_Merchant_Dashboard_State";
  static Set_Merchant_Dashboard_State = "Set_Merchant_Dashboard_State";
}

export class MerchantSetting {
  static Set_Merchant_KeySettings_State = "Set_Merchant_KeySettings_State";
  static Set_GetMerchant_KeySettings_State =
    "Set_GetMerchant_KeySettings_State";
  static Wallet_Alert = "Wallet_Alert";
  static View_Wallet_Limit = "View_Wallet_Limit";
  static Change_Pin = "Change_Pin";
  static Reset_Pin = "Reset_Pin";
}
export class MerchantWallet {
  static Set_Merchant_WalletTransaction_State =
    "Set_Merchant_WalletTransaction_State";
  static Set_GetMerchant_WalletTransaction_State =
    "Set_GetMerchant_WalletTransaction_State";
  static Get_Wallet_Commission = "Get_Wallet_Commission";
  static Transfer_Commission = "Transfer_Commission";
  static Filter_WalletTransaction = "Filter_WalletTransaction";
  static Filter_WalletTransactionCommission =
    "Filter_WalletTransactionCommission";
}

export class MerchantReport {
  static Set_GetMerchant_Report_State = "Set_GetMerchant_Report_State";
  static Set_Merchant_Report_State = "Set_Merchant_Report_State";
  static GET_MERCHANT_SETTLEMENTS = "GET_MERCHANT_SETTLEMENTS"
  static Filter_Report = "Filter_Report";
  static Get_Receipt = "Get_Receipt";
  static SEND_DAILY_REPORT = "SEND_DAILY_REPORT"
  static FILTER_SETTLEMEMT = "FILTER_SETTLEMEMT"
}

export class AuditLog {
  static Set_Audit_Logs = "Set_Audit_Logs";
  static Get_Audit_Logs = "Get_Audit_Logs";
  static Filter_Audit_Logs = "Filter_Audit_Logs";
}
export class APILoaderAction {
  static SET_API_LOADING_STATE = "SET_API_LOADING_STATE";
  static SET_MODAL = "SET_MODAL";
}

export class MerchantProfile {
  static SET_MERCHANT_PROFILE_STATE = "SET_MERCHANT_PROFILE_STATE";
  static GET_KYC_TIER = "GET_KYC_TIER";
  static UPDATE_MERCHANT_PROFILE = "UPDATE_MERCHANT_PROFILE";
  static GET_MERCHANT_PROFILE_STATE = "GET_MERCHANT_PROFILE_STATE";
  static SUBMIT_KYC = "SUBMIT_KYC";
}

export class Transaction {
  static SET_TRANSACTION = "SET_TRANSACTION";
  static GET_TRANSACTION_CATEGORY = "GET_TRANSACTION_CATEGORY";
  static GET_TRANSACTION_BILLER = "GET_TRANSACTION_BILLER";
  static GET_TRANSACTION_PRODUCT = "GET_TRANSACTION_PRODUCT";
  static PERFORM_ACTION = "PERFORM_ACTION";
  static PIN_VERIFICATION = "PIN_VERIFICATION";
  static CREATE_PIN = "CREATE_PIN";
  static CUSTOMER_LOOK_UP = "CUSTOMER_LOOK_UP";
  static CHANGE_PIN = "CHANGE_PIN";
}

export class BulkAirtime {
  static SET_BULK_AIRTIME = "SET_BULK_AIRTIME";
  static GET_BULK_AIRTIME = "GET_BULK_AIRTIME";
  static GET_SINGLE_BULK_AIRTIME = "GET_SINGLE_BULK_AIRTIME";
  static BULK_UPLOAD = "BULK_UPLOAD"
}
